export default "__VITE_ASSET__C23ROYdn__"